<template>
    <button class="bg-none border border-dark-secondary hover:text-white hover:bg-dark-primary hover:shadow active:bg-dark-primary active:text-gray-400 text-dark-secondary whitespace-nowrap tracking-wider font-medium px-3 py-1 rounded-sm" >
        <slot></slot>
    </button>
</template>

<script setup></script>